module.exports = __webpack_public_path__ + "img/product-details-4.9ea1eb3b.jpg";